var map = {
	"./add-consultation-visit/add-consultation-visit.module": [
		"./src/app/modules/my-works/add-consultation-visit/add-consultation-visit.module.ts",
		"add-consultation-visit-add-consultation-visit-module"
	],
	"./add-note/add-note.module": [
		"./src/app/modules/my-works/add-note/add-note.module.ts",
		"add-note-add-note-module"
	],
	"./add-other-charge/add-other-charge.module": [
		"./src/app/modules/my-works/add-other-charge/add-other-charge.module.ts",
		"add-other-charge-add-other-charge-module"
	],
	"./add-procedure/add-procedure.module": [
		"./src/app/modules/my-works/add-procedure/add-procedure.module.ts",
		"add-procedure-add-procedure-module"
	],
	"./add-vital/add-vital.module": [
		"./src/app/modules/my-works/add-vital/add-vital.module.ts",
		"add-vital-add-vital-module"
	],
	"./alerts-and-allergies/alerts-and-allergies.module": [
		"./src/app/modules/patient/alerts-and-allergies/alerts-and-allergies.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"alerts-and-allergies-alerts-and-allergies-module"
	],
	"./alerts/alerts.module": [
		"./src/app/modules/configuration/alerts/alerts.module.ts",
		"default~alerts-alerts-module~modules-configuration-configuration-module",
		"alerts-alerts-module"
	],
	"./app-settings/app-settings.module": [
		"./src/app/modules/configuration/app-settings/app-settings.module.ts",
		"app-settings-app-settings-module"
	],
	"./audit-log/audit-log.module": [
		"./src/app/modules/my-works/audit-log/audit-log.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"audit-log-audit-log-module"
	],
	"./batch-details/batch-details.module": [
		"./src/app/modules/pharmacy/batch-details/batch-details.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~batch-details-batch-details-module~modules-pharmacy-pharmacy-module"
	],
	"./bed-type/bed-type.module": [
		"./src/app/modules/configuration/bed-type/bed-type.module.ts",
		"default~bed-type-bed-type-module~modules-configuration-configuration-module",
		"bed-type-bed-type-module"
	],
	"./billing/billing.module": [
		"./src/app/modules/patient/billing/billing.module.ts",
		"default~billing-billing-module~encounters-encounters-module~modules-in-patients-in-patients-module~m~3089d629",
		"default~billing-billing-module~discharged-patient-dues-discharged-patient-dues-module~ip-bill-status~cd629bbf",
		"default~billing-billing-module~modules-patient-patient-module",
		"billing-billing-module"
	],
	"./brand-divisions/brand-divisions.module": [
		"./src/app/modules/configuration/brand-divisions/brand-divisions.module.ts",
		"default~brand-divisions-brand-divisions-module~modules-configuration-configuration-module",
		"brand-divisions-brand-divisions-module"
	],
	"./brand-representatives/brand-representatives.module": [
		"./src/app/modules/configuration/brand-representatives/brand-representatives.module.ts",
		"default~brand-representatives-brand-representatives-module~modules-configuration-configuration-modul~b53c36bd",
		"brand-representatives-brand-representatives-module"
	],
	"./brands/brands.module": [
		"./src/app/modules/configuration/brands/brands.module.ts",
		"default~brands-brands-module~modules-configuration-configuration-module",
		"brands-brands-module"
	],
	"./charge-categories/charge-categories.module": [
		"./src/app/modules/configuration/charge-categories/charge-categories.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~charge-categories-charge-categories-module~modules-configuration-configuration-module",
		"charge-categories-charge-categories-module"
	],
	"./charge-items/charge-items.module": [
		"./src/app/modules/configuration/charge-items/charge-items.module.ts",
		"default~charge-items-charge-items-module~modules-configuration-configuration-module",
		"charge-items-charge-items-module"
	],
	"./charges-for-category/charges-for-category.module": [
		"./src/app/modules/configuration/charges-for-category/charges-for-category.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~charges-for-category-charges-for-category-module~modules-configuration-configuration-module"
	],
	"./consultant/consultant.module": [
		"./src/app/modules/patient/consultant/consultant.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~consultant-consultant-module~modules-my-works-my-works-module~modules-patient-patient-module~ed9fe752"
	],
	"./custom-query/custom-query.module": [
		"./src/app/modules/my-works/custom-query/custom-query.module.ts",
		"default~custom-query-custom-query-module~modules-my-works-my-works-module",
		"custom-query-custom-query-module"
	],
	"./discharged-patient-bill/discharged-patient-bill.module": [
		"./src/app/modules/my-works/discharged-patient-bill/discharged-patient-bill.module.ts",
		"discharged-patient-bill-discharged-patient-bill-module"
	],
	"./discharged-patient-dues/discharged-patient-dues.module": [
		"./src/app/modules/my-works/discharged-patient-dues/discharged-patient-dues.module.ts",
		"default~billing-billing-module~discharged-patient-dues-discharged-patient-dues-module~ip-bill-status~cd629bbf",
		"discharged-patient-dues-discharged-patient-dues-module"
	],
	"./discharged-patient-pharmacy-charge/discharged-patient-pharmacy-charge.module": [
		"./src/app/modules/my-works/discharged-patient-pharmacy-charge/discharged-patient-pharmacy-charge.module.ts",
		"discharged-patient-pharmacy-charge-discharged-patient-pharmacy-charge-module"
	],
	"./doctor-schedule/doctor-schedule.module": [
		"./src/app/modules/configuration/doctor-schedule/doctor-schedule.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~doctor-schedule-doctor-schedule-module~modules-configuration-configuration-module"
	],
	"./documents/documents.module": [
		"./src/app/modules/patient/documents/documents.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~documents-documents-module~modules-my-works-my-works-module~modules-patient-patient-module~p~ce522724"
	],
	"./drug-and-generic/drug-and-generic.module": [
		"./src/app/modules/configuration/drug-and-generic/drug-and-generic.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~drug-and-generic-drug-and-generic-module~modules-configuration-configuration-module"
	],
	"./drug-classes/drug-classes.module": [
		"./src/app/modules/configuration/drug-classes/drug-classes.module.ts",
		"default~drug-classes-drug-classes-module~modules-configuration-configuration-module",
		"drug-classes-drug-classes-module"
	],
	"./encounters/encounters.module": [
		"./src/app/modules/patient/encounters/encounters.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~billing-billing-module~encounters-encounters-module~modules-in-patients-in-patients-module~m~3089d629",
		"default~encounters-encounters-module~modules-out-patients-out-patients-module~modules-patient-patien~c9a1411e",
		"default~encounters-encounters-module~modules-patient-patient-module",
		"encounters-encounters-module"
	],
	"./floors/floors.module": [
		"./src/app/modules/configuration/floors/floors.module.ts",
		"default~floors-floors-module~modules-configuration-configuration-module",
		"floors-floors-module"
	],
	"./fsn-report/fsn-report.module": [
		"./src/app/modules/pharmacy/fsn-report/fsn-report.module.ts",
		"fsn-report-fsn-report-module"
	],
	"./generic-names/generic-names.module": [
		"./src/app/modules/configuration/generic-names/generic-names.module.ts",
		"default~generic-names-generic-names-module~modules-configuration-configuration-module",
		"generic-names-generic-names-module"
	],
	"./gst/gst.module": [
		"./src/app/modules/configuration/gst/gst.module.ts",
		"default~gst-gst-module~modules-configuration-configuration-module",
		"gst-gst-module"
	],
	"./hsn-codes/hsn-codes.module": [
		"./src/app/modules/configuration/hsn-codes/hsn-codes.module.ts",
		"default~hsn-codes-hsn-codes-module~modules-configuration-configuration-module~modules-pharmacy-pharm~35be8083",
		"hsn-codes-hsn-codes-module"
	],
	"./internal-code-settings/internal-code-settings.module": [
		"./src/app/modules/configuration/internal-code-settings/internal-code-settings.module.ts",
		"default~internal-code-settings-internal-code-settings-module~modules-pharmacy-pharmacy-module",
		"internal-code-settings-internal-code-settings-module"
	],
	"./ip-aadhaar-card-details/ip-aadhaar-card-details.module": [
		"./src/app/modules/my-works/ip-aadhaar-card-details/ip-aadhaar-card-details.module.ts",
		"ip-aadhaar-card-details-ip-aadhaar-card-details-module"
	],
	"./ip-bill-status/ip-bill-status.module": [
		"./src/app/modules/my-works/ip-bill-status/ip-bill-status.module.ts",
		"default~billing-billing-module~discharged-patient-dues-discharged-patient-dues-module~ip-bill-status~cd629bbf",
		"ip-bill-status-ip-bill-status-module"
	],
	"./ip-doctor-pay/ip-doctor-pay.module": [
		"./src/app/modules/my-works/ip-doctor-pay/ip-doctor-pay.module.ts",
		"ip-doctor-pay-ip-doctor-pay-module"
	],
	"./ip-income-report/ip-income-report.module": [
		"./src/app/modules/my-works/ip-income-report/ip-income-report.module.ts",
		"ip-income-report-ip-income-report-module"
	],
	"./item-wise-product-report/item-wise-product-report.module": [
		"./src/app/modules/pharmacy/item-wise-product-report/item-wise-product-report.module.ts",
		"item-wise-product-report-item-wise-product-report-module"
	],
	"./make-payment-report/make-payment-report.module": [
		"./src/app/modules/pharmacy/make-payment-report/make-payment-report.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"make-payment-report-make-payment-report-module"
	],
	"./master-cities/master-cities.module": [
		"./src/app/modules/configuration/master-cities/master-cities.module.ts",
		"default~master-cities-master-cities-module~modules-configuration-configuration-module",
		"master-cities-master-cities-module"
	],
	"./master-countries/master-countries.module": [
		"./src/app/modules/configuration/master-countries/master-countries.module.ts",
		"default~master-countries-master-countries-module~modules-configuration-configuration-module",
		"master-countries-master-countries-module"
	],
	"./master-states/master-states.module": [
		"./src/app/modules/configuration/master-states/master-states.module.ts",
		"default~master-states-master-states-module~modules-configuration-configuration-module",
		"master-states-master-states-module"
	],
	"./modules/advanced-search/advanced-search.module": [
		"./src/app/modules/advanced-search/advanced-search.module.ts",
		"modules-advanced-search-advanced-search-module"
	],
	"./modules/auth/auth.module": [
		"./src/app/modules/auth/auth.module.ts",
		"modules-auth-auth-module"
	],
	"./modules/configuration/configuration.module": [
		"./src/app/modules/configuration/configuration.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~modules-configuration-configuration-module~modules-lab-lab-module~modules-patient-patient-mo~1de85dd2",
		"default~modules-configuration-configuration-module~modules-lab-lab-module~modules-pharmacy-pharmacy-~a933cd44",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~products-product~bb5114f0",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~patient-groups-p~d4187b14",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~suppliers-suppli~0a580245",
		"default~modules-configuration-configuration-module~role-rights-role-rights-module~roles-roles-module",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~packing-unit-pac~2fed8e56",
		"default~hsn-codes-hsn-codes-module~modules-configuration-configuration-module~modules-pharmacy-pharm~35be8083",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~vats-vats-module",
		"default~modules-configuration-configuration-module~modules-my-works-my-works-module",
		"default~charges-for-category-charges-for-category-module~modules-configuration-configuration-module",
		"default~doctor-schedule-doctor-schedule-module~modules-configuration-configuration-module",
		"default~drug-and-generic-drug-and-generic-module~modules-configuration-configuration-module",
		"default~charge-categories-charge-categories-module~modules-configuration-configuration-module",
		"default~modules-configuration-configuration-module~rooms-rooms-module",
		"default~modules-configuration-configuration-module~room-charge-room-charge-module",
		"default~brand-representatives-brand-representatives-module~modules-configuration-configuration-modul~b53c36bd",
		"default~modules-configuration-configuration-module~product-types-product-types-module",
		"default~modules-configuration-configuration-module~patient-grouping-patient-grouping-module",
		"default~master-cities-master-cities-module~modules-configuration-configuration-module",
		"default~generic-names-generic-names-module~modules-configuration-configuration-module",
		"default~master-states-master-states-module~modules-configuration-configuration-module",
		"default~alerts-alerts-module~modules-configuration-configuration-module",
		"default~modules-configuration-configuration-module~room-and-bed-type-room-and-bed-type-module",
		"default~modules-configuration-configuration-module~patient-categories-patient-categories-module",
		"default~modules-configuration-configuration-module~specialities-specialities-module",
		"default~charge-items-charge-items-module~modules-configuration-configuration-module",
		"default~modules-configuration-configuration-module~wards-wards-module",
		"default~modules-configuration-configuration-module~schedule-of-drugs-schedule-of-drugs-module",
		"default~brands-brands-module~modules-configuration-configuration-module",
		"default~master-countries-master-countries-module~modules-configuration-configuration-module",
		"default~brand-divisions-brand-divisions-module~modules-configuration-configuration-module",
		"default~floors-floors-module~modules-configuration-configuration-module",
		"default~drug-classes-drug-classes-module~modules-configuration-configuration-module",
		"default~bed-type-bed-type-module~modules-configuration-configuration-module",
		"default~modules-configuration-configuration-module~routes-routes-module",
		"default~gst-gst-module~modules-configuration-configuration-module",
		"default~modules-configuration-configuration-module~modules-lab-lab-module",
		"modules-configuration-configuration-module"
	],
	"./modules/in-patients/in-patients.module": [
		"./src/app/modules/in-patients/in-patients.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~billing-billing-module~encounters-encounters-module~modules-in-patients-in-patients-module~m~3089d629",
		"modules-in-patients-in-patients-module"
	],
	"./modules/lab/lab.module": [
		"./src/app/modules/lab/lab.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~modules-configuration-configuration-module~modules-lab-lab-module~modules-patient-patient-mo~1de85dd2",
		"default~modules-lab-lab-module~modules-patient-patient-module~prescriptions-prescriptions-module~req~0734a092",
		"default~modules-configuration-configuration-module~modules-lab-lab-module~modules-pharmacy-pharmacy-~a933cd44",
		"default~modules-configuration-configuration-module~modules-lab-lab-module",
		"modules-lab-lab-module"
	],
	"./modules/my-works/my-works.module": [
		"./src/app/modules/my-works/my-works.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~modules-my-works-my-works-module~modules-patient-patient-module~pharmacy-indent-pharmacy-ind~471cde20",
		"default~documents-documents-module~modules-my-works-my-works-module~modules-patient-patient-module~p~ce522724",
		"default~modules-my-works-my-works-module~modules-patient-patient-module~pharmacy-indent-pharmacy-ind~41a2ea8a",
		"default~consultant-consultant-module~modules-my-works-my-works-module~modules-patient-patient-module~ed9fe752",
		"default~modules-my-works-my-works-module~patient-results-patient-results-module~pharmacy-indent-phar~aeea7484",
		"default~modules-my-works-my-works-module~pharmacy-indent-pharmacy-indent-module~prescriptions-prescr~9e400d15",
		"default~modules-configuration-configuration-module~modules-my-works-my-works-module",
		"default~modules-my-works-my-works-module~pharmacy-indent-pharmacy-indent-module",
		"default~modules-my-works-my-works-module~mrd-mrd-module",
		"default~custom-query-custom-query-module~modules-my-works-my-works-module",
		"modules-my-works-my-works-module"
	],
	"./modules/out-patients/out-patients.module": [
		"./src/app/modules/out-patients/out-patients.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~encounters-encounters-module~modules-out-patients-out-patients-module~modules-patient-patien~c9a1411e",
		"modules-out-patients-out-patients-module"
	],
	"./modules/patient-registration/patient-registration.module": [
		"./src/app/modules/patient-registration/patient-registration.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"modules-patient-registration-patient-registration-module"
	],
	"./modules/patient/patient.module": [
		"./src/app/modules/patient/patient.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~modules-my-works-my-works-module~modules-patient-patient-module~pharmacy-indent-pharmacy-ind~471cde20",
		"default~documents-documents-module~modules-my-works-my-works-module~modules-patient-patient-module~p~ce522724",
		"default~modules-my-works-my-works-module~modules-patient-patient-module~pharmacy-indent-pharmacy-ind~41a2ea8a",
		"default~consultant-consultant-module~modules-my-works-my-works-module~modules-patient-patient-module~ed9fe752",
		"default~billing-billing-module~encounters-encounters-module~modules-in-patients-in-patients-module~m~3089d629",
		"default~modules-configuration-configuration-module~modules-lab-lab-module~modules-patient-patient-mo~1de85dd2",
		"default~modules-lab-lab-module~modules-patient-patient-module~prescriptions-prescriptions-module~req~0734a092",
		"default~billing-billing-module~discharged-patient-dues-discharged-patient-dues-module~ip-bill-status~cd629bbf",
		"default~encounters-encounters-module~modules-out-patients-out-patients-module~modules-patient-patien~c9a1411e",
		"default~modules-patient-patient-module~prescriptions-prescriptions-module~request-and-result-request~f82750e0",
		"default~billing-billing-module~modules-patient-patient-module",
		"default~encounters-encounters-module~modules-patient-patient-module",
		"default~modules-patient-patient-module~procedures-procedures-module",
		"default~modules-patient-patient-module~notes-notes-module",
		"modules-patient-patient-module"
	],
	"./modules/pharmacy/pharmacy.module": [
		"./src/app/modules/pharmacy/pharmacy.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~modules-configuration-configuration-module~modules-lab-lab-module~modules-pharmacy-pharmacy-~a933cd44",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~products-product~bb5114f0",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~patient-groups-p~d4187b14",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~suppliers-suppli~0a580245",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~packing-unit-pac~2fed8e56",
		"default~hsn-codes-hsn-codes-module~modules-configuration-configuration-module~modules-pharmacy-pharm~35be8083",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~vats-vats-module",
		"default~modules-pharmacy-pharmacy-module~sales-sales-module",
		"default~modules-pharmacy-pharmacy-module~purchases-purchases-module",
		"default~modules-pharmacy-pharmacy-module~reorders-reorders-module",
		"default~modules-pharmacy-pharmacy-module~stock-transfer-stock-transfer-module",
		"default~modules-pharmacy-pharmacy-module~purchase-returns-purchase-returns-module",
		"default~modules-pharmacy-pharmacy-module~sale-returns-sale-returns-module",
		"default~batch-details-batch-details-module~modules-pharmacy-pharmacy-module",
		"default~internal-code-settings-internal-code-settings-module~modules-pharmacy-pharmacy-module",
		"modules-pharmacy-pharmacy-module"
	],
	"./modules/static-pages/static-pages.module": [
		"./src/app/modules/static-pages/static-pages.module.ts",
		"modules-static-pages-static-pages-module"
	],
	"./mrd/mrd.module": [
		"./src/app/modules/my-works/mrd/mrd.module.ts",
		"default~modules-my-works-my-works-module~mrd-mrd-module"
	],
	"./new-purchase-report/new-purchase-report.module": [
		"./src/app/modules/pharmacy/new-purchase-report/new-purchase-report.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"new-purchase-report-new-purchase-report-module"
	],
	"./non-moving-report/non-moving-report.module": [
		"./src/app/modules/pharmacy/non-moving-report/non-moving-report.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"non-moving-report-non-moving-report-module"
	],
	"./non-recurring-charge/non-recurring-charge.module": [
		"./src/app/modules/my-works/non-recurring-charge/non-recurring-charge.module.ts",
		"non-recurring-charge-non-recurring-charge-module"
	],
	"./notes/notes.module": [
		"./src/app/modules/patient/notes/notes.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~modules-patient-patient-module~notes-notes-module"
	],
	"./op-daily-report/op-daily-report.module": [
		"./src/app/modules/my-works/op-daily-report/op-daily-report.module.ts",
		"op-daily-report-op-daily-report-module"
	],
	"./op-non-recurring-charge-reports/op-non-recurring-charge-reports.module": [
		"./src/app/modules/my-works/op-non-recurring-charge-reports/op-non-recurring-charge-reports.module.ts",
		"op-non-recurring-charge-reports-op-non-recurring-charge-reports-module"
	],
	"./op-payments/op-payments.module": [
		"./src/app/modules/my-works/op-payments/op-payments.module.ts",
		"op-payments-op-payments-module"
	],
	"./op-summary-reports/op-summary-reports.module": [
		"./src/app/modules/my-works/op-summary-reports/op-summary-reports.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"op-summary-reports-op-summary-reports-module"
	],
	"./overall-income-report/overall-income-report.module": [
		"./src/app/modules/pharmacy/overall-income-report/overall-income-report.module.ts",
		"overall-income-report-overall-income-report-module"
	],
	"./packing-unit/packing-unit.module": [
		"./src/app/modules/configuration/packing-unit/packing-unit.module.ts",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~packing-unit-pac~2fed8e56",
		"packing-unit-packing-unit-module"
	],
	"./patient-categories/patient-categories.module": [
		"./src/app/modules/configuration/patient-categories/patient-categories.module.ts",
		"default~modules-configuration-configuration-module~patient-categories-patient-categories-module",
		"patient-categories-patient-categories-module"
	],
	"./patient-grouping/patient-grouping.module": [
		"./src/app/modules/configuration/patient-grouping/patient-grouping.module.ts",
		"default~modules-configuration-configuration-module~patient-grouping-patient-grouping-module",
		"patient-grouping-patient-grouping-module"
	],
	"./patient-groups/patient-groups.module": [
		"./src/app/modules/configuration/patient-groups/patient-groups.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~patient-groups-p~d4187b14"
	],
	"./patient-merge/patient-merge.module": [
		"./src/app/modules/my-works/patient-merge/patient-merge.module.ts",
		"patient-merge-patient-merge-module"
	],
	"./patient-outstanding-report/patient-outstanding-report.module": [
		"./src/app/modules/pharmacy/patient-outstanding-report/patient-outstanding-report.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"patient-outstanding-report-patient-outstanding-report-module"
	],
	"./patient-results/patient-results.module": [
		"./src/app/modules/patient/patient-results/patient-results.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~modules-my-works-my-works-module~patient-results-patient-results-module~pharmacy-indent-phar~aeea7484"
	],
	"./patient-wise-sale-report/patient-wise-sale-report.module": [
		"./src/app/modules/pharmacy/patient-wise-sale-report/patient-wise-sale-report.module.ts",
		"patient-wise-sale-report-patient-wise-sale-report-module"
	],
	"./pharmacy-indent/pharmacy-indent-module": [
		"./src/app/modules/my-works/pharmacy-indent/pharmacy-indent-module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~modules-my-works-my-works-module~modules-patient-patient-module~pharmacy-indent-pharmacy-ind~471cde20",
		"default~documents-documents-module~modules-my-works-my-works-module~modules-patient-patient-module~p~ce522724",
		"default~modules-my-works-my-works-module~modules-patient-patient-module~pharmacy-indent-pharmacy-ind~41a2ea8a",
		"default~consultant-consultant-module~modules-my-works-my-works-module~modules-patient-patient-module~ed9fe752",
		"default~modules-my-works-my-works-module~patient-results-patient-results-module~pharmacy-indent-phar~aeea7484",
		"default~modules-my-works-my-works-module~pharmacy-indent-pharmacy-indent-module~prescriptions-prescr~9e400d15",
		"default~modules-my-works-my-works-module~pharmacy-indent-pharmacy-indent-module",
		"pharmacy-indent-pharmacy-indent-module"
	],
	"./prescription-register/prescription-register.module": [
		"./src/app/modules/pharmacy/prescription-register/prescription-register.module.ts",
		"prescription-register-prescription-register-module"
	],
	"./prescriptions/prescriptions.module": [
		"./src/app/modules/patient/prescriptions/prescriptions.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~modules-my-works-my-works-module~modules-patient-patient-module~pharmacy-indent-pharmacy-ind~471cde20",
		"default~documents-documents-module~modules-my-works-my-works-module~modules-patient-patient-module~p~ce522724",
		"default~modules-my-works-my-works-module~modules-patient-patient-module~pharmacy-indent-pharmacy-ind~41a2ea8a",
		"default~consultant-consultant-module~modules-my-works-my-works-module~modules-patient-patient-module~ed9fe752",
		"default~modules-configuration-configuration-module~modules-lab-lab-module~modules-patient-patient-mo~1de85dd2",
		"default~modules-lab-lab-module~modules-patient-patient-module~prescriptions-prescriptions-module~req~0734a092",
		"default~modules-my-works-my-works-module~patient-results-patient-results-module~pharmacy-indent-phar~aeea7484",
		"default~modules-patient-patient-module~prescriptions-prescriptions-module~request-and-result-request~f82750e0",
		"default~modules-my-works-my-works-module~pharmacy-indent-pharmacy-indent-module~prescriptions-prescr~9e400d15",
		"prescriptions-prescriptions-module"
	],
	"./print-settings/print-settings.module": [
		"./src/app/modules/configuration/print-settings/print-settings.module.ts",
		"print-settings-print-settings-module"
	],
	"./procedure-patient-report/procedure-patient-report.module": [
		"./src/app/modules/my-works/procedure-patient-report/procedure-patient-report.module.ts",
		"procedure-patient-report-procedure-patient-report-module"
	],
	"./procedures/procedures.module": [
		"./src/app/modules/patient/procedures/procedures.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~billing-billing-module~encounters-encounters-module~modules-in-patients-in-patients-module~m~3089d629",
		"default~modules-patient-patient-module~procedures-procedures-module",
		"procedures-procedures-module"
	],
	"./product-types/product-types.module": [
		"./src/app/modules/configuration/product-types/product-types.module.ts",
		"default~modules-configuration-configuration-module~product-types-product-types-module",
		"product-types-product-types-module"
	],
	"./products/products.module": [
		"./src/app/modules/configuration/products/products.module.ts",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~products-product~bb5114f0",
		"products-products-module"
	],
	"./purchase-gst-report/purchase-gst-report.module": [
		"./src/app/modules/pharmacy/purchase-gst-report/purchase-gst-report.module.ts",
		"purchase-gst-report-purchase-gst-report-module"
	],
	"./purchase-report/purchase-report.module": [
		"./src/app/modules/pharmacy/purchase-report/purchase-report.module.ts",
		"purchase-report-purchase-report-module"
	],
	"./purchase-returns/purchase-returns.module": [
		"./src/app/modules/pharmacy/purchase-returns/purchase-returns.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~modules-pharmacy-pharmacy-module~purchase-returns-purchase-returns-module"
	],
	"./purchases/purchases.module": [
		"./src/app/modules/pharmacy/purchases/purchases.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~modules-pharmacy-pharmacy-module~purchases-purchases-module",
		"purchases-purchases-module"
	],
	"./recurring-charge/recurring-charge.module": [
		"./src/app/modules/my-works/recurring-charge/recurring-charge.module.ts",
		"recurring-charge-recurring-charge-module"
	],
	"./reorders/reorders.module": [
		"./src/app/modules/pharmacy/reorders/reorders.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~modules-pharmacy-pharmacy-module~reorders-reorders-module",
		"reorders-reorders-module"
	],
	"./request-and-result/request-and-result.module": [
		"./src/app/modules/patient/request-and-result/request-and-result.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~modules-my-works-my-works-module~modules-patient-patient-module~pharmacy-indent-pharmacy-ind~471cde20",
		"default~modules-configuration-configuration-module~modules-lab-lab-module~modules-patient-patient-mo~1de85dd2",
		"default~modules-lab-lab-module~modules-patient-patient-module~prescriptions-prescriptions-module~req~0734a092",
		"default~modules-patient-patient-module~prescriptions-prescriptions-module~request-and-result-request~f82750e0"
	],
	"./role-rights/role-rights.module": [
		"./src/app/modules/configuration/role-rights/role-rights.module.ts",
		"default~modules-configuration-configuration-module~role-rights-role-rights-module~roles-roles-module",
		"role-rights-role-rights-module"
	],
	"./roles/roles.module": [
		"./src/app/modules/configuration/roles/roles.module.ts",
		"default~modules-configuration-configuration-module~role-rights-role-rights-module~roles-roles-module",
		"roles-roles-module"
	],
	"./room-and-bed-type/room-and-bed-type.module": [
		"./src/app/modules/configuration/room-and-bed-type/room-and-bed-type.module.ts",
		"default~modules-configuration-configuration-module~room-and-bed-type-room-and-bed-type-module",
		"room-and-bed-type-room-and-bed-type-module"
	],
	"./room-charge/room-charge.module": [
		"./src/app/modules/configuration/room-charge/room-charge.module.ts",
		"default~modules-configuration-configuration-module~room-charge-room-charge-module",
		"room-charge-room-charge-module"
	],
	"./rooms/rooms.module": [
		"./src/app/modules/configuration/rooms/rooms.module.ts",
		"default~modules-configuration-configuration-module~rooms-rooms-module",
		"rooms-rooms-module"
	],
	"./routes/routes.module": [
		"./src/app/modules/configuration/routes/routes.module.ts",
		"default~modules-configuration-configuration-module~routes-routes-module",
		"routes-routes-module"
	],
	"./sale-gst-group-wise/sale-gst-group-wise.module": [
		"./src/app/modules/pharmacy/sale-gst-group-wise/sale-gst-group-wise.module.ts",
		"sale-gst-group-wise-sale-gst-group-wise-module"
	],
	"./sale-gst-report/sale-gst-report.module": [
		"./src/app/modules/pharmacy/sale-gst-report/sale-gst-report.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"sale-gst-report-sale-gst-report-module"
	],
	"./sale-report/sale-report.module": [
		"./src/app/modules/pharmacy/sale-report/sale-report.module.ts",
		"sale-report-sale-report-module"
	],
	"./sale-return-report/sale-return-report.module": [
		"./src/app/modules/pharmacy/sale-return-report/sale-return-report.module.ts",
		"sale-return-report-sale-return-report-module"
	],
	"./sale-returns/sale-returns.module": [
		"./src/app/modules/pharmacy/sale-returns/sale-returns.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~modules-pharmacy-pharmacy-module~sale-returns-sale-returns-module"
	],
	"./sales/sales.module": [
		"./src/app/modules/pharmacy/sales/sales.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~modules-pharmacy-pharmacy-module~sales-sales-module",
		"sales-sales-module"
	],
	"./schedule-of-drugs/schedule-of-drugs.module": [
		"./src/app/modules/configuration/schedule-of-drugs/schedule-of-drugs.module.ts",
		"default~modules-configuration-configuration-module~schedule-of-drugs-schedule-of-drugs-module",
		"schedule-of-drugs-schedule-of-drugs-module"
	],
	"./share-modules/share-modules.module": [
		"./src/app/modules/patient/share-modules/share-modules.module.ts",
		"share-modules-share-modules-module"
	],
	"./short-expiry-report/short-expiry-report.module": [
		"./src/app/modules/pharmacy/short-expiry-report/short-expiry-report.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"short-expiry-report-short-expiry-report-module"
	],
	"./sold-quantity-report/sold-quantity-report.module": [
		"./src/app/modules/pharmacy/sold-quantity-report/sold-quantity-report.module.ts",
		"sold-quantity-report-sold-quantity-report-module"
	],
	"./specialities/specialities.module": [
		"./src/app/modules/configuration/specialities/specialities.module.ts",
		"default~modules-configuration-configuration-module~specialities-specialities-module",
		"specialities-specialities-module"
	],
	"./stock-adjust/stock-adjust.module": [
		"./src/app/modules/pharmacy/stock-adjust/stock-adjust.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"stock-adjust-stock-adjust-module"
	],
	"./stock-report/stock-report.module": [
		"./src/app/modules/pharmacy/stock-report/stock-report.module.ts",
		"stock-report-stock-report-module"
	],
	"./stock-transfer-report/stock-transfer-report.module": [
		"./src/app/modules/pharmacy/stock-transfer-report/stock-transfer-report.module.ts",
		"stock-transfer-report-stock-transfer-report-module"
	],
	"./stock-transfer/stock-transfer.module": [
		"./src/app/modules/pharmacy/stock-transfer/stock-transfer.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~modules-pharmacy-pharmacy-module~stock-transfer-stock-transfer-module"
	],
	"./suppliers/suppliers.module": [
		"./src/app/modules/configuration/suppliers/suppliers.module.ts",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~suppliers-suppli~0a580245",
		"suppliers-suppliers-module"
	],
	"./time-line/time-line.module": [
		"./src/app/modules/patient/time-line/time-line.module.ts",
		"time-line-time-line-module"
	],
	"./user-branches/user-branches.module": [
		"./src/app/modules/configuration/user-branches/user-branches.module.ts",
		"user-branches-user-branches-module"
	],
	"./user-roles/user-roles.module": [
		"./src/app/modules/configuration/user-roles/user-roles.module.ts",
		"user-roles-user-roles-module"
	],
	"./users/users.module": [
		"./src/app/modules/configuration/users/users.module.ts",
		"default~modules-configuration-configuration-module~modules-lab-lab-module~modules-pharmacy-pharmacy-~a933cd44"
	],
	"./vats/vats.module": [
		"./src/app/modules/configuration/vats/vats.module.ts",
		"default~modules-configuration-configuration-module~modules-pharmacy-pharmacy-module~vats-vats-module",
		"vats-vats-module"
	],
	"./view/view.module": [
		"./src/app/modules/patient/view/view.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"view-view-module"
	],
	"./vital-management/vital-management.module": [
		"./src/app/modules/configuration/vital-management/vital-management.module.ts",
		"vital-management-vital-management-module"
	],
	"./vitals/vitals.module": [
		"./src/app/modules/patient/vitals/vitals.module.ts",
		"default~alerts-and-allergies-alerts-and-allergies-module~batch-details-batch-details-module~charge-c~db6d11ce",
		"default~alerts-and-allergies-alerts-and-allergies-module~audit-log-audit-log-module~consultant-consu~80932c27",
		"default~modules-my-works-my-works-module~modules-patient-patient-module~pharmacy-indent-pharmacy-ind~471cde20",
		"default~modules-my-works-my-works-module~modules-patient-patient-module~pharmacy-indent-pharmacy-ind~41a2ea8a"
	],
	"./wards/wards.module": [
		"./src/app/modules/configuration/wards/wards.module.ts",
		"default~modules-configuration-configuration-module~wards-wards-module",
		"wards-wards-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;